export const ALL_INCIDENT_LEVELS = ['L1', 'L1.5', 'Data Sheet', 'L2'];
/** First status: school can still edit the L1. */
export const NEW_STATUS = 0;
/** After Request L1.5: L1 is no longer editable in the portal. */
export const OPENED_STATUS = 1;
/** Closed via POST /api/external/Incidents/{id}/close. */
export const CLOSED_STATUS = 3;
export function isClosedIncidentStatus(status) {
    return Number(status) === CLOSED_STATUS;
}
export function isIncidentLevel(value) {
    return value === 'L1' || value === 'L1.5' || value === 'Data Sheet' || value === 'L2';
}
export function normalizeIncidentLevels(value) {
    if (!Array.isArray(value))
        return [...ALL_INCIDENT_LEVELS];
    const selected = value.filter(isIncidentLevel);
    return selected.length > 0 ? selected : [...ALL_INCIDENT_LEVELS];
}
export function isEscalationLevel(level) {
    return level === 'L1.5' || level === 'Data Sheet' || level === 'L2';
}
/** List order under an L1 parent: L1.5, then L2, then Data Sheet. */
const CHILD_LEVEL_ORDER = {
    L1: 0,
    'L1.5': 1,
    L2: 2,
    'Data Sheet': 3,
};
export function compareChildIncidentLevel(a, b) {
    const aOrder = a != null ? CHILD_LEVEL_ORDER[a] : 99;
    const bOrder = b != null ? CHILD_LEVEL_ORDER[b] : 99;
    return aOrder - bOrder;
}
/**
 * Classify from issue-type name and/or ids.
 * L1.5 / Data Sheet are checked before L1 so those names are not treated as L1.
 */
export function classifyIncidentLevel(issueType, issueTypeIds, config) {
    const ids = Array.isArray(issueTypeIds)
        ? issueTypeIds.filter((id) => typeof id === 'number' && Number.isFinite(id))
        : [];
    if (ids.includes(config.dataSheetIssueTypeId))
        return 'Data Sheet';
    if (ids.includes(config.l15IssueTypeId))
        return 'L1.5';
    if (config.l2IssueTypeId != null &&
        config.l2IssueTypeId > 0 &&
        ids.includes(config.l2IssueTypeId)) {
        return 'L2';
    }
    const name = (issueType ?? '').trim();
    if (!name && ids.length === 0)
        return null;
    if (/data\s*sheet/i.test(name))
        return 'Data Sheet';
    if (/L1\s*\.?\s*5\b/i.test(name) || /L1\.5/i.test(name))
        return 'L1.5';
    if (/^L2\b/i.test(name))
        return 'L2';
    if (/^L1\b/i.test(name))
        return 'L1';
    return null;
}
export function incidentLevelLabel(level) {
    return level ?? '—';
}
export function isIssueTypeRoot(entry) {
    return entry.parentId == null || entry.parentId === 0;
}
/** Top-level "L1 - …" type, never L1.5. */
export function isL1RootIssueType(entry) {
    const name = (entry.name ?? '').trim();
    return isIssueTypeRoot(entry) && /^L1\b/i.test(name) && !/L1\s*\.?\s*5/i.test(name);
}
/** Parent L1 type first, then its child screening reasons. */
export function l1FamilyIssueTypes(issueTypes) {
    const root = issueTypes.find(isL1RootIssueType);
    if (!root)
        return { root: undefined, options: [] };
    const options = issueTypes
        .filter((entry) => entry.id === root.id || entry.parentId === root.id)
        .sort((a, b) => {
        if (a.id === root.id)
            return -1;
        if (b.id === root.id)
            return 1;
        return (a.name ?? '').localeCompare(b.name ?? '');
    });
    return { root, options };
}
